import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
  },

  mutations: {
  },

  actions: {
    updateAccount: ({ commit }, userData) => {
      return new Promise((resolve, reject) => {
        axios.post('/user/updateAccount', userData).then(response => {
          resolve(response.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    updateUserName: ({ commit }, username) => {
      return new Promise((resolve, reject) => {
        commit('UPDATE_USER_NAME', username)
        resolve()
      })
    }
  },

  getters: {

  }
}



// WEBPACK FOOTER //
// ./client/store/modules/myAccount.js